// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-element{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;height:100%;word-break:break-word;transition:opacity 0.3s linear}a.text-element{display:block;text-decoration:none}a.text-element:hover{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
